import { FormControl, Input, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import * as React from 'react';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { CREDENTIALS_QUERY_PARAMS } from '../credentials-table/filtering';

export const Search: React.FC = () => {
  const { searchParams, setSearchParams } = useCustomSearchParams(CREDENTIALS_QUERY_PARAMS);

  const [search, setSearch] = React.useState(searchParams.search || '');

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (search) {
          setSearchParams({ search });
        }
      }}
      className="flex-grow"
    >
      <FormControl variant="standard" className="w-4/12">
        <Input
          placeholder={searchParams.search || 'Search portals'}
          fullWidth
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          }
          endAdornment={
            searchParams.search && (
              <InputAdornment position="end">
                <ClearIcon
                  onClick={() => {
                    setSearch('');
                    setSearchParams({ search: undefined });
                  }}
                  className="cursor-pointer"
                />
              </InputAdornment>
            )
          }
          onChange={(e) => setSearch(e.target.value)}
          value={search}
        />
      </FormControl>
    </form>
  );
};
Search.displayName = 'Search';
